module.exports = __webpack_public_path__ + "72e953fb371777f87f774e81551f68a3.png";